import styled from 'styled-components';
import Content from '@src/components/Organism/Card/Content';
import { devices } from '@src/styles/theme';
import { IBoardContent, IContent } from '@src/interfaces/community';
import { useRouter } from 'next/router';
import NewContent from '@src/components/Organism/Card/NewContent';

/**
 *
 * @returns 카드 컴포넌트의 최상위부모로 카드에 관한 컴포넌트를 조합하여 하나의 템플릿으로 만들어서 사용한다.
 */
type Props = {
  image: boolean;
  community: IContent | IBoardContent;
  communityType?: string; // donation인지? board인지?
  isNew?: boolean; // 기존 카드인지 새롭게 만들어진 card인지 왜냐하면 기존에 Content컴포넌트가 너무 조건식이 많다.
};

/**
 *
 * @param param0
 * 헌혈요청과, 커뮤니티 부분에 사용되는 Card 탬플릿이다.
 * @returns
 */
const CardTemplate = ({ image, community, communityType, isNew }: Props) => {
  const router = useRouter();
  return (
    <>
      <CardContainer
        onClick={() => {
          if (communityType) {
            router.push(`/community/${communityType}/detail/${community.uuid}`);
          } else {
            sessionStorage.setItem('reviews_scroll', String(window.scrollY));
            router.push(`${router.pathname}/detail/${community.uuid}`);
          }
        }}
      >
        {!isNew && <Content community={community} image={image} />}
        {isNew && <NewContent community={community} image={image} />}
      </CardContainer>
    </>
  );
};

const CardContainer = styled.div`
  border-radius: 10px;
  background-color: ${({ theme }) => theme.commonColor.white};
  border: 1px solid ${({ theme }) => theme.commonColor.gray002};
  padding: 1rem 2rem;
  cursor: pointer;
  margin-bottom: 10px;
  @media ${devices.tablet} {
    /* display: none; */
    border: none;
    border-radius: 0px;
  }
`;

export default CardTemplate;
